<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YDJgQq/tc-custom/9781526759436.jpg?1726755951765" alt="This image is the cover for the book Phoenix 13"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Phoenix 13
      </h1>
      <p class="bookDescription body article font2">
        <b>“An informative and colorful memoir about the role that observation helicopters played during the Vietnam War . . . Phoenix 13 delivers.” —<i>The VVA Veteran</i></b><br/><br/>A collection of war stories closely based on the author’s experiences flying scout/observation helicopters in Vietnam. Storytelling was a daily evening occurrence for the solo scout pilots. These stories, called “TINS,” an irreverent pilot acronym for “this is no shit,” allowed the solo pilots to learn from each other’s experiences and mistakes. The TINS within this collection reveal the brotherhood that developed between pilots and their crew chiefs in combat. The solo pilots relied on their courage, swapping stories and a bit of luck to survive.<br/><br/><b>“A compelling collection of Vietnam helicopter true stories about the aviators in Americal Division’s Artillery Aviation Section in ’68 and ’69. Flying alone, the scout pilots told their exploits to each other daily to learn and to survive from their collective experiences. Hazardous missions are intermixed with occasional humorous details of their off-duty shenanigans. The stories describe the brotherhood that develops between soldiers during combat. From these stories, the author, a decorated former Army aviator, describes his journey through Armor school, flight school and Vietnam.” —General Tommy Franks (Ret), Former Commander in Chief, United States Central Command </b><br/><br/><b>“A very enjoyable read. Those of us who were there will thoroughly enjoy it, and those who weren’t will learn more about what we did in Vietnam.” —<i>The VHPA Aviator</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Darryl James
      </h2>
      
      <p class="authorDescription body article">The author flew scout helicopters during the Vietnam War. He is now a petroleum geologist working in the oil and gas industry.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6162ff27